import * as React from "react"
import { App } from "./app"
import { BDKalkCore } from "./BDKalkCore"
import { Assert } from "./PADebug"
import { SelectionSetGW } from "./SelectionSetGW"
import { BuildPartGW } from "./BuildPartGW"
import { PageBrowser } from "./PageBrowser"

///////////////   BuildPartView  ////////////////

/* BuildPartView displays all build parts saved by the logged in user and makes them accessible. */

export interface BuildPartViewVm  {
    app: App
}

export interface BuildPartViewStateVm {
    stage: string
}

export class BuildPartView extends React.Component<BuildPartViewVm, BuildPartViewStateVm> {
    constructor(props: BuildPartViewVm) {
        super(props)
        this.m_hoveredItem = -1
        this.m_loadingDots = 2
        this.m_pageBrowser = new PageBrowser()
        this.m_pageBrowser.initiate( this.props.app.state.resultGroupLength, this.props.app.state.resultGroupRange, "bygningsdeler", "(Ingen bygningsdel funnet)")
        this.m_pageBrowser.connect(this.onUpdateFromPageBrowser.bind(this), this.GetTotalAmount.bind(this))
    }

    // 
    state = {
        stage: "initial"
    }

    onUpdateFromPageBrowser() {
        this.forceUpdate()
    }

    GetTotalAmount() {
        return this.props.app.GetCore().GetBuildParts().length
    }

    //
    componentWillMount() {
        this.props.app.GetCore().ConnectBuildPartView(this)
        setTimeout( this.LoadDotUpdate.bind(this) , 400 )
    }

    // Bottom scoop means the user moved the mouse below the project item list, and this actiom will un hover the bottom project item
    onBottomScoop() {
        this.props.app.GetCore().GetSelectionSetManager().SetHoveredBuildPartIndex(-1)
        this.forceUpdate()
    }

    // 
    onMouseLeave() {
        this.props.app.GetCore().GetSelectionSetManager().SetHoveredBuildPartIndex(-1)
        this.forceUpdate()
    }

    // 
    render() {
        const core = this.props.app.GetCore() 

        var loadSign = <div></div>

        if (this.props.app.GetCore().HasUnloadedBuildParts() == true) {
            this.m_loadingDots++

            if (this.m_loadingDots == 1) {
                loadSign = <div style={{ marginLeft: "35px" }} >Laster ner bygningsdeler.</div>
            }

            if (this.m_loadingDots == 2) {
                loadSign = <div style={{ marginLeft: "35px" }} >Laster ner bygningsdeler..</div>
            }

            if (this.m_loadingDots == 3) {
                loadSign = <div style={{ marginLeft: "35px" }} >Laster ner bygningsdeler...</div>
            }

            if (this.m_loadingDots == 4) {
                loadSign = <div style={{ marginLeft: "35px" }} >Laster ner bygningsdeler....</div>
                this.m_loadingDots = 0
            }
        }
        
        // Checks if the user wants to overwrite a saved project with the identical name
        if (this.state.stage == "deleteQuestion") {
            if ((this.m_deleteBuildPartContentBPOccurances != null) && (this.m_deleteBuildPartContentProjectOccurances != null)) {

                if (this.m_deleteBuildPartContentBPOccurances.length > 0) {
                    var elements_bd: Array<JSX.Element> | null = new Array<JSX.Element>()
                    elements_bd.push(<div>Bygningsdeler som blir påvirket er:</div>)
                    var key = 0
                    for (var i = 0; i < this.m_deleteBuildPartContentBPOccurances.length; i++) {
                        const keyStr = (key++).toString()
                        elements_bd.push(<div key={keyStr} style={{ color: "red" }}>{this.m_deleteBuildPartContentBPOccurances[i].GetTitle()}</div>)
                    }

                    elements_bd.push(<div style={{ height: "20px" }}></div>)

                    if (elements_bd.length < 3) {
                        elements_bd = null
                    }

                    var elements_proj: Array<JSX.Element> | null = new Array<JSX.Element>()
                    elements_proj.push(<div>Utvalg som blir påvirket er:</div>)
                    
                    for (var i = 0; i < this.m_deleteBuildPartContentProjectOccurances.length; i++) {
                        const keyStr = (key++).toString()
                        elements_proj.push(<div key={keyStr} style={{ color: "red" }}>{this.m_deleteBuildPartContentProjectOccurances[i].GetTitle()}</div>)
                    }

                    if (elements_proj.length < 2) {
                        elements_proj = null
                    }

                    return <div style={{ display: "flex", flexDirection: "row" }}>
                        <div style={{ width: "calc(50% - 50px)", height: "1px" }}>
                        </div>
                        <div style={{ position: "relative", top: "80px", display: "flex", flexDirection: "column" }}>

                            <div>Den bygningsdel du vil slette finns inkludert </div>
                            <div>innen andre bygningsdeler eller utvalg, vilka </div>
                            <div>kommer til å påvirkes gjennom at den valgte</div>
                            <div>bygningsdelen førsvinner fra disse</div>
                            <div>bygningsdeler og utvalg.</div>
                            <div style={{ height: "20px" }}></div>
                            
                            {elements_bd}
                            {elements_proj}

                            <div style={{ position: "relative", top: "5px", display: "flex", flexDirection: "row" }}>
                                <div onClick={this.OnDeleteSure.bind(this)} style={{ backgroundColor: "grey", width: "66px", height: "30px", position: "relative", top: "20px", cursor: "pointer" }}>
                                    <div style={{ position: "relative", top: "6px", left: "12px", color: "white", cursor: "pointer" }}>
                                        Slette
                                    </div>
                                </div>

                                <div onClick={this.OnCansel.bind(this)} style={{ backgroundColor: "grey", width: "74px", height: "30px", position: "relative", top: "20px", left: "20px", cursor: "pointer" }}>
                                    <div style={{ position: "relative", top: "6px", left: "12px", color: "white", cursor: "pointer" }}>
                                        Avbryt
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                }
            }
            else {
                Assert(false, "BuildPartView.render - the m_deleteBuildPartContentBPOccurances or m_deleteBuildPartContentProjectOccurances was null!")
            }
           
            return <div style={{ display: "flex", flexDirection: "row" }}>
                <div style={{ width: "calc(50% - 50px)", height: "1px" }}>
                </div>
                <div style={{ position: "relative", top: "80px", display: "flex", flexDirection: "column" }}>
                    <div>Er du sikker på at du vil</div>
                    <div>slette denne bygningsdel:</div>
                    <div>{this.m_itemToDelete.GetName()}</div>

                    <div style={{ position: "relative", top: "5px", display: "flex", flexDirection: "row" }}>
                        <div onClick={this.OnDeleteSure.bind(this)} style={{ backgroundColor: "grey", width: "64px", height: "30px", position: "relative", top: "20px", cursor: "pointer" }}>
                            <div style={{ position: "relative", top: "6px", left: "12px", color: "white", cursor: "pointer" }}>
                                Slette
                            </div>
                        </div>

                        <div onClick={this.OnCansel.bind(this)} style={{ backgroundColor: "grey", width: "74px", height: "30px", position: "relative", top: "20px", left: "20px", cursor: "pointer" }}>
                            <div style={{ position: "relative", top: "6px", left: "12px", color: "white", cursor: "pointer" }}>
                                Avbryt
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        }

        return <div onMouseLeave={this.onMouseLeave.bind(this)}>

            {/* Top margin: */} 
            <div style={{height:"9px", width:"100%"}}> 
            </div>

            {/* Title: */}
            <div style={{ height: "52px", fontSize: "26px", fontWeight: "bold", marginLeft:"35px" }}>
                Bygningsdeler:
            </div>

            <div style={{ height: "82px", marginLeft: "35px" }}>
                {this.m_pageBrowser.render(false)}
            </div>
            
            {/* column tops: */}
            <div onMouseEnter={this.onMouseLeave.bind(this)} style={{ display: "flex", flexDirection: "row", height: "30px", fontWeight:"bold" }}> 
                <div style={{ width: "125px", fontSize: "16px", marginLeft: "35px" }}>Antall</div>
                <div style={{ width: "306px", fontSize: "16px" }}>Tittel</div>
                <div style={{ width: "120px", fontSize: "16px", textAlign: "right" }}>Pris</div>
                <div style={{ width: "140px", fontSize: "16px", textAlign: "right" }}>Sum</div>
            </div>

            {/* Byggdel list: */}
            <div>
                {core.GetSelectionSetManager().RenderBuildParts(this.m_pageBrowser.GetCurrentStartPosition(), this.m_pageBrowser.GetCurrentEndPosition())}
                {loadSign}
            </div>

            {/* bottom scoop: */}
            <div style={{ width: "100%", height: "50px" }} onMouseEnter={this.onBottomScoop.bind(this)}>
            </div>

            <div style={{ height: "52px", marginLeft: "35px" }}>
                {this.m_pageBrowser.render(true)}
            </div>
        </div>
    }

    // self repeating method while leading build parts, to show dot stages
    LoadDotUpdate() {
        if (this.props.app.GetCore().HasUnloadedBuildParts() == true) {
            setTimeout(this.LoadDotUpdate.bind(this), 300)
            this.forceUpdate()
        }
    }
    
    SetHoveredItem(index: number) {
        this.m_hoveredItem = index
    }

    GetHoveredItem() {
        return this.m_hoveredItem
    }
    
    OnDeleteSure() {
        this.props.app.GetCore().GetSelectionSetManager().DeleteProject(this.m_itemToDelete)
    }

    OnCansel() {
        this.setState({ stage:"initial"})
    }

    SetItemToDelete(set: SelectionSetGW) {
        this.m_itemToDelete = set
    }

    m_hoveredItem: number
    m_itemToDelete: SelectionSetGW

    public SetDeleteAffectionBPOccurances(occurances: Array<BuildPartGW>) {
        this.m_deleteBuildPartContentBPOccurances = occurances
    }

    public SetDeleteAffectionProjectOccurances(occurances: Array<BuildPartGW>) {
        this.m_deleteBuildPartContentProjectOccurances = occurances
    }

    private m_deleteBuildPartContentBPOccurances: Array<BuildPartGW>
    private m_deleteBuildPartContentProjectOccurances: Array<BuildPartGW>

    private m_loadingDots: number

    private m_pageBrowser: PageBrowser
}


// WEBPACK FOOTER //
// ./client/view/BuildPartView.tsx